import { type PrimaryCategoryConfigUserConstructor } from '@webapp/platform/organization-management/entities/PrimaryCategoryConfigUser'
import { type PrimaryCategoryConfigUserApiModel } from '../api-models/PrimaryCategoryConfigUserApiModel'

export const mapPrimaryCategoryConfigUserApiModel = (
  apiModel: PrimaryCategoryConfigUserApiModel
): PrimaryCategoryConfigUserConstructor => ({
  id: apiModel.id,
  firstName: apiModel.firstName,
  lastName: apiModel.lastName,
  profileImage: apiModel.profile_image,
  roleName: apiModel.role.name,
  roleType: apiModel.role.type,
})
